<template>
    <div class="Navbar">
        <nav class="navbar navbar-dark bg-primary">
            <a class="navbar-brand" href="https://www.youtube.com/channel/UCvdqZ92DnIXTi4N5ixy8aYA">Buscador UNI</a>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'Navbar',
}
</script>

<style>

</style>